'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.appconfgroups.list', [])
  .controller('AppConfGroupsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfgroups/list/index.js